import { Component, OnInit } from '@angular/core';
import { ContentfulService } from '../contentful.service';
import { Router } from "@angular/router";
import { Entry } from 'contentful';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {

  public about : Entry<any>[] = [];
  
  constructor(private contentfulService: ContentfulService) { }

  ngOnInit() {
    this.about = this.contentfulService.about;
  }

}



// WEBPACK FOOTER //
// C:/Users/timva/Documents/Work/LatestDownload/src/app/about/about.component.ts